import ButtonContainedMixin from './mixins/button-contained-mixin.js';
import ButtonSmallMixin from './mixins/button-small-mixin.js';
import TpButton from './tp-button.js';

export default class TpButtonContainedSmall extends
  ButtonSmallMixin(
  ButtonContainedMixin(
    TpButton
  )) {}
